<template>
    <div>
        <h3 class="font-bold text-2xl mb-4">{{ $t("accreditedStatusVerification") }}</h3>
        <p>
            {{
                $t("accreditedStatusDesc")
            }}
        </p>
        <div class="mt-6">
            <div class="font-semibold text-sm mt-6">
                1. In the preceding 12 months you declare that you had:
            </div>
            <div v-if="fieldError('kycQuestionAnnualIncome')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('kycQuestionAnnualIncome') }}
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionAnnualIncome" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionAnnualIncome" value="ANNUAL_INCOME_LESS_THAN_100K">
                    <span class="text-sm">An annual income of less than SGD 100,000</span>
                </label>
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionAnnualIncome" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionAnnualIncome" value="ANNUAL_INCOME_LESS_THAN_300K">
                    <span class="text-sm">An annual income between SGD 100,000 and SGD 299,999</span>
                </label>
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionAnnualIncome" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionAnnualIncome" value="ANNUAL_INCOME_MORE_THAN_300K">
                    <span class="text-sm">An annual income of SGD 300,000 or more</span>
                </label>
            </div>

            <div class="font-semibold text-sm mt-6">
                2. The value of your Net Personal Assets (1) :
            </div>
            <div v-if="fieldError('kycQuestionPersonalAssets')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('kycQuestionPersonalAssets') }}
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionPersonalAssets" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionPersonalAssets" value="PERSONAL_ASSETS_LESS_THAN_2M">
                    <span class="text-sm">Is less than SGD 2 million</span>
                </label>
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionPersonalAssets" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionPersonalAssets" value="PERSONAL_ASSETS_MORE_THAN_2M">
                    <span class="text-sm">Is SGD 2 million or more</span>
                </label>
            </div>

            <div class="font-semibold text-sm mt-6">
                3. The Value of your Net Financial Assets (2) :
            </div>
            <div v-if="fieldError('kycQuestionFinancialAssets')"
                 class="text-red-500 text-xs italic">
                {{ fieldError('kycQuestionFinancialAssets') }}
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionFinancialAssets" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionFinancialAssets" value="FINANCIAL_ASSETS_LESS_THAN_1M">
                    <span class="text-sm">Is less than SGD 1 million </span>
                </label>
            </div>
            <div class="mt-3">
                <label class="block text-gray-700 flex items-center cursor-pointer">
                    <input v-model="form.kycQuestionFinancialAssets" class="mr-2 leading-tight" type="radio"
                           name="kycQuestionFinancialAssets" value="FINANCIAL_ASSETS_MORE_THAN_1M">
                    <span class="text-sm">Is SGD 1 million or more</span>
                </label>
            </div>
            <div class="mt-3">
                <small>All amounts are stated in Singaporean dollar or its equivalent in the foreign currency</small>
            </div>
            <div class="mt-10">
                <k-button @click.native.prevent="onSubmit">
                    Submit
                </k-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        validation: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: {
                kycQuestionAnnualIncome: '',
                kycQuestionPersonalAssets: '',
                kycQuestionFinancialAssets: '',
            }
        };
    },
    methods: {
        fieldError(field) {
            return this.validation.fieldErrors[field];
        },
        async onSubmit() {
            this.$emit('submit', this.form);
        }
    }
};
</script>

